import { useState, useEffect } from 'react'
import API from 'api'
import reject from 'lodash/reject'
import { convertCurrency } from '../../helpers/PriceConverter'
import { getProductCategory } from '../../dive-guides/gtm-events'
import { setBrandValue } from '../../../gtm'

export default function useNearByActivites({
  activityId,
  type,
  coords,
  showAllOnFail,
}) {
  const [isLoading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [nothingFound, setNothingFound] = useState(false)

  const options = {
    uniq_activity: true,
    point: coords ? `${coords.latitude},${coords.longitude}` : undefined,
  }

  useEffect(() => {
    getData(options)
  }, [coords])

  useEffect(() => {
    if(items.length) {
      items.forEach((product) => {
        const { type } = getProductCategory(50)
        const { currency, price } = product.price
        const { diveCenter } = product
        product.impression = {
          name: product.titleEn || product.title,
          id: product.activityId,
          price: convertCurrency(
            price,
            currency,
            window.currency,
            false,
            true
          ).toFixed(2),
          brand: setBrandValue(diveCenter),
          category: type,
        }
        product.actionField = showAllOnFail
          ? 'Travel Adventures - Conservation Activity Landing Page - Popular'
          : 'Travel Adventures - Conservation Activity Event Page - Nearby Activities'
      })
      // window.dataLayer.push({
      //   event: 'impression',
      //   ecommerce: {
      //     currencyCode: window.currency,
      //     impressions: impressions,
      //   },
      // })
    }
  }, [items])

  const getData = (coords) => {
    API(`/api/adventure/v1/search/${type}/nearby/`)
      .get(coords)
      .then((data) => {
        const allItems = reject(data, { activityId })
        if(showAllOnFail && !allItems.length) {
          setNothingFound(true)
          API('/api/adventure/v1/search/location/all/conservation/')
            .get({
              page: 1,
            })
            .then(({ results }) => {
              setItems(results)
              setLoading(false)
            })
        } else {
          setItems(allItems)
          setLoading(false)
        }
      })
  }

  return { items, isLoading, nothingFound }
}
